import { useMutation } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { ADD_JOB_OFFER_DRAFT_PRO, ADD_JOB_OFFER_DRAFT_UPERCUT } from '@gql/jobs';

export const useAddJobOfferDraft = () => {
    const { user, isUpercut } = useAuth();
    const { isProIdRequired } = useProId();

    const mutationToUse = isUpercut && !isProIdRequired
        ? ADD_JOB_OFFER_DRAFT_UPERCUT
        : ADD_JOB_OFFER_DRAFT_PRO;

    const [mutate, { loading, error }] = useMutation(mutationToUse);

    const addDraft = async (payload: any) => {
        const result = await mutate({
            variables: { payload },
        });

        const jobOffer = isUpercut && !isProIdRequired
            ? result.data?.addJobOfferDraftUpercut
            : result.data?.addJobOfferDraftPro;

        return jobOffer;
    };

    return {
        addDraft,
        loading,
        error,
        isUpercut,
        userRole: user?.role,
    };
};
